import {
  FaTools,
  FaLightbulb,
  FaHandsHelping,
  FaCheckCircle,
  FaClock,
  FaDraftingCompass,
  FaUserFriends,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaHome,
  FaBuilding,
  FaUserShield,   
  FaShieldAlt,    
  FaStopwatch,
  FaDollarSign,
  
} from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import {
  blog1,
  blog2,
  blog3,
  blog4

} from "./assets";

// src/data.js (excerpt)
export const navigations = [
  {
    tKey: "nav.joinUs",
    label: "Join Us",
    to: "about",
    submenu: [
      { tKey: "nav.careers", label: "Careers", path: "/careers" }
    ],
  },
  {
    tKey: "nav.securitySolutions",
    label: "Security Solutions",
    to: "services", // top-level still scrolls to Services section on home
    submenu: [
      { tKey: "services.eventSecurity",        label: "EVENT SECURITY",        path: "/services/event-security" },
      { tKey: "services.residentialSecurity",  label: "RESIDENTIAL SECURITY",  path: "/services/residential-security" },
      { tKey: "services.businessSecurity",     label: "BUSINESS SECURITY",     path: "/services/business-security" },
      { tKey: "services.trafficControl",       label: "TRAFFIC CONTROL",       path: "/services/traffic-control" },
      { tKey: "services.fireSurveillance",     label: "FIRE SURVEILLANCE",     path: "/services/fire-surveillance" },
      { tKey: "services.hospitalityServices",  label: "HOSPITALITY SERVICES",  path: "/services/hospitality-services" },
      { tKey: "services.luxurySecurity",       label: "LUXURY SECURITY",       path: "/services/luxury-security" },
      { tKey: "services.lossPrevention",       label: "LOSS PREVENTION",       path: "/services/loss-prevention" },
      { tKey: "services.interventionServices", label: "INTERVENTION SERVICES", path: "/services/intervention-services" },
      { tKey: "services.constructionSecurity", label: "CONSTRUCTION SITE SECURITY", path: "/services/construction-site-services" },
      { tKey: "services.patrolServices",       label: "PATROL SERVICES",       path: "/services/patrol-services" },
      { tKey: "services.vipSecurity",          label: "V.I.P SECURITY SERVICES", path: "/services/VIP-security-services" }
    ],
  },
  {
    tKey: "nav.whoWeServe",
    label: "Who We Serve",
    to: "portfolio",
    submenu: [
      { tKey: "who.education",               label: "Education",                  path: "/who-we-serve/education" },
      { tKey: "who.commercialProperties",    label: "Commercial Properties",      path: "/who-we-serve/commercial-properties" },
      { tKey: "who.constructionSites",       label: "Construction Sites",         path: "/who-we-serve/construction-sites" },
      { tKey: "who.financialIndustry",       label: "Financial Industry",         path: "/who-we-serve/financial-industry" },
      { tKey: "who.governmentServices",      label: "Government Services",        path: "/who-we-serve/government-services" },
      { tKey: "who.warehouses",              label: "Warehouses",                 path: "/who-we-serve/warehouses" },
      { tKey: "who.events",                  label: "Events",                     path: "/who-we-serve/events" },
      { tKey: "who.illegallyOccupiedProps",  label: "Illegally Occupied Properties", path: "/who-we-serve/illegally-occupied-properties" },
      { tKey: "who.retailStores",            label: "Retail Stores",              path: "/who-we-serve/retail-stores" },
      { tKey: "who.hotels",                  label: "Hotels",                     path: "/who-we-serve/hotels" }
    ],
  },
  {
    tKey: "nav.getAQuote",
    label: "Get a Quote",
    to: "team",
    submenu: [
      { tKey: "nav.requestQuote",     label: "Request a Quote",     path: "/contact#quote-request" },
      { tKey: "nav.consultationCall", label: "Consultation Call",   action: "openPhoneModal" }
    ],
  },
  {
    tKey: "nav.blog",
    label: "Blog",
    path: "/blog/foundation",
    submenu: [
      { tKey: "nav.latestNews", label: "Latest News", path: "/blog/foundation" }
    ],
  },
];




export const keypoints = [
  {
    icon: <FaTools />,
    title: "Expert Craftsmanship",
  },
  {
    icon: <FaRegClock />,
    title: "On-Time, Within Budget",
  },
  {
    icon: <FaLightbulb />,
    title: "Innovative Solutions",
  },
  {
    icon: <FaHandsHelping />,
    title: "Client-Centered Approach",
  },
];

export const whyChooseUs = [
  {
    // Fallbacks (current text)
    title: "PROFESSIONNEL PERSONNEL",
    description:
      "All of our agents are experienced, highly trained, and dedicated to protecting your facilities, property, and community.",

    // i18n keys
    tTitle: "wcu.cards.professionalStaff.title",
    tDesc: "wcu.cards.professionalStaff.desc",

    icon: <FaUserShield />,
  },
  {
    title: "SAFETY FIRST",
    description:
      "Each of our security officers is CPR and First Aid certified, ensuring they are prepared for any emergency.",

    tTitle: "wcu.cards.safetyFirst.title",
    tDesc: "wcu.cards.safetyFirst.desc",

    icon: <FaShieldAlt />,
  },
  {
    title: "FAIR PRICING",
    description:
      "Understanding that trust is built on honesty, we guarantee full transparency in our pricing and services — no hidden fees, fair pricing.",

    tTitle: "wcu.cards.bestPrices.title",
    tDesc: "wcu.cards.bestPrices.desc",

    icon: <FaDollarSign />,
  },
];

export const services = [
  {
    title: "Residential Construction",
    icon: <FaHome />,
    description: `This is example text for the residential construction service.`,
  },
  {
    title: "Commercial Projects",
    icon: <FaBuilding />,
    description: `This is example text for the commercial projects service.`,
  },
  {
    title: "Renovation & Remodeling",
    icon: <FaTools />,
    description: `This is example text for the renovation and remodeling service.`,
  },
];
export const portfolio = [
  // Portfolio items removed - add new portfolio items here when you have images
];

export const teamMembers = [
  // Team members removed - add new team members here when you have images
];


export const testimonials = [
  {
    id: 1,
    // Fallbacks (English inline)
    name: "Sarah Johnson",
    title: "Property Manager",
    company: "Downtown Commercial Plaza",
    content:
      "Vision Sécurité has been our trusted security partner for over 3 years. Their guards are professional, reliable, and always maintain the highest standards. Our tenants feel safe, and that's invaluable.",
    rating: 5,
    industry: "Commercial Real Estate",

    // i18n keys
    tName: "team.cards.1.name",
    tTitle: "team.cards.1.title",
    tCompany: "team.cards.1.company",
    tContent: "team.cards.1.content",
    tIndustry: "team.cards.1.industry"
  },
  {
    id: 2,
    name: "Michael Chen",
    title: "Event Director",
    company: "Montreal Festival Coalition",
    content:
      "We've worked with Vision Sécurité on numerous large-scale events. Their crowd management expertise and rapid response capabilities are unmatched. Highly recommended for any event security needs.",
    rating: 5,
    industry: "Events & Entertainment",

    tName: "team.cards.2.name",
    tTitle: "team.cards.2.title",
    tCompany: "team.cards.2.company",
    tContent: "team.cards.2.content",
    tIndustry: "team.cards.2.industry"
  },
  {
    id: 3,
    name: "Amanda Rodriguez",
    title: "Operations Manager",
    company: "TechHub Montreal",
    content:
      "The 24/7 monitoring and quick response times have given us complete peace of mind. Vision Sécurité's team understands our unique needs and delivers consistent, professional service.",
    rating: 5,
    industry: "Technology",

    tName: "team.cards.3.name",
    tTitle: "team.cards.3.title",
    tCompany: "team.cards.3.company",
    tContent: "team.cards.3.content",
    tIndustry: "team.cards.3.industry"
  },
  {
    id: 4,
    name: "David Thompson",
    title: "Site Supervisor",
    company: "Heritage Construction",
    content:
      "Construction site security is critical for us. Vision Sécurité's guards are vigilant, understand construction environments, and have prevented multiple incidents. Excellent partnership.",
    rating: 5,
    industry: "Construction",

    tName: "team.cards.4.name",
    tTitle: "team.cards.4.title",
    tCompany: "team.cards.4.company",
    tContent: "team.cards.4.content",
    tIndustry: "team.cards.4.industry"
  },
  {
    id: 5,
    name: "Lisa Park",
    title: "Facilities Director",
    company: "Montreal Medical Center",
    content:
      "In healthcare, security requires sensitivity and professionalism. Vision Sécurité's team handles challenging situations with care while maintaining our facility's safety standards.",
    rating: 5,
    industry: "Healthcare",

    tName: "team.cards.5.name",
    tTitle: "team.cards.5.title",
    tCompany: "team.cards.5.company",
    tContent: "team.cards.5.content",
    tIndustry: "team.cards.5.industry"
  }
];

export const blogs = [
  {
    tTitle: "blogs.visionFoundation.title",
    tExcerpt: "blogs.visionFoundation.excerpt",
    tContent: "blogs.visionFoundation.content",
    tAuthor: "blogs.visionFoundation.author",

    title: "Read About Vision Foundation",
    slug: "vision-foundation",
    linkTo: "/blog/foundation", // <-- CORRECTED THIS LINE
    excerpt:
      "The Vision Foundation supports the poor, homeless, and families in need across our community. Learn how you can help—through donations, volunteering, or outreach.",
    content:
      "The Vision Foundation focuses on helping the poor, homeless, and needy families in our community. Your support—through donations, volunteering, or outreach—can make a tangible difference. Join us in creating a direct impact locally. Together, let's help those in need.",
    author: "Vision Sécurité Team",
    date: "2025-10-01",
    readTime: 2,
    image: blog1
  },
  {
    tTitle: "blogs.breakingBoundaries.title",
    tExcerpt: "blogs.breakingBoundaries.excerpt",
    tContent: "blogs.breakingBoundaries.content",
    tAuthor: "blogs.breakingBoundaries.author",

    title: "Breaking Boundaries: Our Journey Toward Nationwide Presence",
    slug: "breaking-boundaries",
    type: "article",
    linkTo: "/blog/breaking-boundaries",
    excerpt:
      "From Montreal to Toronto: Building a Safer, Stronger Canada with a commitment to proactive security and nationwide expansion.",
    content:
      "What began in Montreal quickly grew into a vision for nationwide coverage. From Quebec to Ontario, we’ve raised the bar in security services and are now building a team for the future. Our mission is not just to react but to proactively identify vulnerabilities before they become threats, ensuring peace of mind across Canada.",
    author: "Vision Sécurité Team",
    // NOTE: normalize to ISO yyyy-mm-dd (was 2025-9-15)
    date: "2025-09-15",
    readTime: 6,
    image: blog2
  },
  {
    tTitle: "blogs.nextGenTraining.title",
    tExcerpt: "blogs.nextGenTraining.excerpt",
    tContent: "blogs.nextGenTraining.content",
    tAuthor: "blogs.nextGenTraining.author",

    title: "Building the Next Generation of Security Professionals",
    slug: "building-the-next-generation",
    type: "article",
    linkTo: "/blog/building-the-next-generation",
    excerpt:
      "Our BSP-accredited security guard training program is reshaping the future of security in Quebec by raising the bar on professional standards and training.",
    content:
      "Over 18 months ago, we began building something we believe will change the future of security in Quebec: our very own BSP-accredited security guard training program. After identifying major flaws in how the course was traditionally taught, we committed nearly 1,000 hours of development and significant financial investment into creating a program that raises the bar for training. Our mission is simple—to ensure every security professional is equipped, confident, and prepared for the realities of the job.\n\nWe designed this program with one goal in mind: to strengthen the labor force in the security industry. Unlike many existing courses, ours is intentionally more challenging, ensuring that graduates aren’t just certified—they’re truly ready to handle the wide range of situations they’ll face in the field. While we continue to patiently await our license approval, we are confident that this course will become one of the most rigorous and effective training programs in the province.\n\n**Preparing Our Workforce in the Meantime**\n\nSix months ago, anticipating our license, we invested in a fully equipped classroom and training tools. Rather than letting them sit unused, we chose to immediately put them to work for our existing workforce. Today, we offer specialized in-house training modules, such as:\n\n- Intervention & De-escalation Training\n- Professional Etiquette & Customer Service Training\n\n**Intervention & De-escalation Training**\n\nThis course equips our agents with the skills to recognize, prevent, and respond to conflicts effectively. From mastering de-escalation strategies to knowing the correct course of action in high-pressure scenarios, this training ensures our officers act with both confidence and professionalism.\n\nBefore launching the program, we tested our agents’ baseline knowledge. The results were eye-opening: the average score across the group was under 50%. This only reinforced what we already knew—ongoing training is the single most valuable investment we can make in our team.\n\n**Professional Etiquette & Customer Service Training**\n\nSecurity isn’t just about presence—it’s about professionalism. Our etiquette and customer service course emphasizes the importance of communication, respect, and approachability. Whether interacting with clients, tenants, or the general public, agents learn how to represent not only themselves, but the reputation of the entire industry. A well-trained officer can de-escalate conflict before it begins, simply by demonstrating composure and professionalism.\n\n**What Sets Vision Apart**\n\nAt Vision, we don’t settle for the minimum standards—we create new ones. By investing heavily in training, raising expectations, and holding our people accountable to the highest levels of professionalism, we ensure our team delivers results that few others can match. This commitment to excellence is what separates Vision from the rest of the industry.",
    author: "Vision Sécurité Team",
    date: "2025-08-18",
    readTime: 7,
    image: blog4
  },
  {
    tTitle: "blogs.storiesFromField.title",
    tExcerpt: "blogs.storiesFromField.excerpt",
    tContent: "blogs.storiesFromField.content",
    tAuthor: "blogs.storiesFromField.author",

    slug: "stories-from-the-field",
    title: "Real Problems, Real Solutions: Stories from the Field",
    type: "blog",
    linkTo: "/blog/stories-from-the-field",
    excerpt:
      "From securing high-profile events to handling dangerous situations, these are the real stories where our agents made a difference.",
    content:
      "From routine bag checks to assisting in the capture of dangerous criminals, our agents at Vision have experienced it all. This page is dedicated to commemorating some of the most remarkable moments from the field — the times when our team’s vigilance, professionalism, and quick thinking made a real difference. Here, you’ll find stories of dangerous criminal organizations we've helped the police disrupt, challenges our agents have faced head-on during high-profile events, and unforgettable experiences that showcase the resilience, courage, and dedication of our team. These are more than just stories — they are testaments to the strength of our people, the trust of our clients, and the impact that professional security can have in keeping communities safe.",
    author: "Vision Sécurité Team",
    date: "2025-09-01",
    readTime: 5,
    image: blog3
  }
];



export const footer = [
  {
    title: "Join Us",
    routes: [
      {
        name: "Careers",
        href: "/careers",
      }
    ],
  },

 {
  title: "Security Solutions",
  routes: [
    { name: "Event Security", href: "/services/event-security" },
    { name: "Residential Security", href: "/services/residential-security" },
    { name: "Business Security", href: "/services/business-security" },
    { name: "Traffic Control", href: "/services/traffic-control" },
    { name: "Fire Surveillance", href: "/services/fire-surveillance" },
    { name: "Luxury Security", href: "/services/luxury-security" },
    { name: "Loss Prevention", href: "/services/loss-prevention" },
    { name: "Intervention Services", href: "/services/intervention-services" },
    { name: "Construction Site Security", href: "/services/construction-site-services" },
    { name: "Patrol Services", href: "/services/patrol-services" },
    { name: "V.I.P Security Services", href: "/services/VIP-security-services" }
  ]
},

  {
    title: "Who We Serve",
    routes: [
      {
        name: "Education",
        href: "/who-we-serve/education",
      },
      {
        name: "Commercial Properties",
        href: "/who-we-serve/commercial-properties",
      },
      {
        name: "Construction Sites",
        href: "/who-we-serve/construction-sites",
      },
      {
        name: "Government Services",
        href: "/who-we-serve/government-services",
      },
       {
        name: "Warehouses",
        href: "/who-we-serve/warehouses",
      },
      {
        name: "Events",
        href: "/who-we-serve/events",
      },
      {
        name: "Illegally Occupied Properties",
        href: "/who-we-serve/illegally-occupied-properties",
      },
      {
        name: "Retail Stores",
        href: "/who-we-serve/retail-stores",
      },
       {
        name: "Hotels",
        href: "/who-we-serve/hotels",
      },
    ],
  },
  {
    title: "Get a Quote",
    routes: [
      {
        name: "Request a Quote",
        href: "/contact",
      },
      {
        name: "Consultation Call",
        href: "/contact",
      },
      {
        name: "Site Assessment",
        href: "/contact",
      },
    ],
  },
  {
    title: "Blog",
    routes: [
      {
        name: "Latest News",
        href: "/blog/foundation",
      },

    ],
  },
];

export const socialHandles = [
  {
    name: "Facebook",
    icon: <FaFacebook />,
    link: "https://www.facebook.com/p/Visionsecurite-100079664496184/",
  },
  {
    name: "Instagram",
    icon: <FaInstagram />,
    link: "https://www.instagram.com/visionsecurity.inc/?hl=en",
  },
  {
    name: "LinkedIn",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/company/vision-s%C3%A9curit%C3%A9-inc/posts/?feedView=all",
  },
  
];


